import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import panzoom from "panzoom";
import { Image } from 'angular-responsive-carousel';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit, OnDestroy {
  @Input() imgSrc: string = ''
  @Input() calledFromCarousel: boolean = false
  public fitDimension = "height"
  public isFullScreen: boolean = false
  public zoomThreshold = 0.2
  
  constructor() { }
  @ViewChild('gridElement', { static: true }) private gridElement: ElementRef | undefined;
  @ViewChild('gridElementViewer', { static: true }) private gridElementViewer: ElementRef | undefined;
  panZoomController:any;
  zoomLevels: number[] = [];
  currentZoomLevel: number = 1;
  
  ngOnInit(): void {
  }

  ngAfterViewInit(): void{
    this.panZoomController = panzoom(this.gridElement?.nativeElement);
    let img = new Image() ;
    img.src = this.imgSrc;
    img.onload= (event) => {
      this.zoomToFillScreen()
      this.centerContent()
    }
  }

  ngOnDestroy(): void {
    this.panZoomController.dispose()
  }

  onZoomInClicked(): void {
    let transform = this.panZoomController.getTransform();
    let deltaX = transform.x;
    let deltaY = transform.y;
    let elementScale = this.panZoomController.getTransform().scale
    let newScale = elementScale + this.zoomThreshold;
    let offsetX = newScale + deltaX;
    let offsetY = newScale + deltaY;
    this.panZoomController.zoomAbs(offsetX, offsetY, newScale);
  }

  onZoomOutClicked(): void {
    let transform = this.panZoomController.getTransform();
    let deltaX = transform.x;
    let deltaY = transform.y;
    let elementScale = this.panZoomController.getTransform().scale
    let newScale = elementScale - this.zoomThreshold;
    let offsetX = newScale + deltaX;
    let offsetY = newScale + deltaY;
    this.panZoomController.zoomAbs(offsetX, offsetY, newScale);
  }

  onResetViewClicked(): void {
    this.zoomToFillScreen()
    this.centerContent()  
  }

  onCenterContentClicked(): void {
    this.centerContent()
  }

  centerContent(): void{
    let viewWidth = this.gridElementViewer?.nativeElement.clientWidth;
    let viewHeight = this.gridElementViewer?.nativeElement.clientHeight;
    let height = this.gridElement?.nativeElement.clientHeight;
    let width = this.gridElement?.nativeElement.clientWidth;
    let elementScale = this.panZoomController.getTransform().scale
    let scaledWidth = width * elementScale;
    let scaledHeight = height * elementScale;
    let translateWidth = 0
    let translateHeight = 0
    translateWidth = (viewWidth - scaledWidth) / 2
    translateHeight = (viewHeight - scaledHeight) / 2
    this.panZoomController.moveTo(translateWidth, translateHeight)
  }

  zoomToFillScreen():void{
    let viewWidth = this.gridElementViewer?.nativeElement.clientWidth;
    let viewHeight = this.gridElementViewer?.nativeElement.clientHeight;
    let height = this.gridElement?.nativeElement.clientHeight;
    let width = this.gridElement?.nativeElement.clientWidth;
    let scaleToFit = 1.0
    if(this.fitDimension == "width"){
      scaleToFit = viewWidth/width
    }
    else{
      scaleToFit = viewHeight/height
    }
    this.panZoomController.zoomAbs(0, 0, scaleToFit)     
  }

  fullscreenToggled(e:any): void {
    if(e == "enter"){
      this.isFullScreen = true
      let img = new Image() ;
      img.src = this.imgSrc;
      img.onload= (event) => {
        this.onResetViewClicked()
      }
    }
    else if (e == "exit"){
      this.isFullScreen = false
      let img = new Image() ;
      img.src = this.imgSrc;
      img.onload= (event) => {
        this.onResetViewClicked()
      }
    }
  }

}
